import React from 'react';
import { Card, CardContent } from './ui/card';
import { useLanguage } from '../context/LanguageContext';
import { Award, Cpu, HeartHandshake, CheckCircle2 } from 'lucide-react';

const iconComponents = [Award, Cpu, HeartHandshake];

const WhyChooseSection = () => {
  const { t } = useLanguage();

  return (
    <section id="whychoose" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header - Centered */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold mb-6" style={{ color: '#1F4FD8' }}>
            {t.whyChoose.title}
            {t.whyChoose.titleHighlight}
          </h2>
          <span
            data-testid="smartmicro-partner-badge"
            className="inline-block px-4 py-1 rounded-full text-sm font-semibold mb-4"
            style={{ backgroundColor: '#E5E7EB', color: '#1F4FD8' }}
          >
            Smartmicro Partner
          </span>
          <p className="text-lg text-slate-600">
            {t.whyChoose.subtitle}
          </p>
        </div>

        {/* Benefits List - Centered */}
        <div className="max-w-3xl mx-auto">
          <ul className="space-y-4">
            {t.whyChoose.benefits.map((benefit, index) => (
              <li key={index} className="flex items-start gap-3">
                <CheckCircle2 className="w-6 h-6 flex-shrink-0 mt-0.5" style={{ color: '#1F4FD8' }} />
                <span className="text-slate-700">{benefit}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Cards Grid */}
        {t.whyChoose.items.length > 0 && (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {t.whyChoose.items.map((item, index) => {
              const IconComponent = iconComponents[index];
              return (
                <Card
                  key={index}
                  className="group bg-white border border-slate-200 hover:border-blue-200 shadow-sm hover:shadow-lg transition-all duration-300"
                >
                  <CardContent className="p-6 flex gap-5">
                    <div className="w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg group-hover:scale-110 transition-transform duration-300" style={{ backgroundColor: '#1F4FD8', boxShadow: '0 8px 20px rgba(31, 79, 216, 0.2)' }}>
                      {IconComponent && <IconComponent className="w-7 h-7 text-white" />}
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-slate-900 mb-1">
                        {item.title}
                      </h3>
                      <p className="text-slate-600 text-sm leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default WhyChooseSection;
